<template>
  <div class="pa-4 mt-3 matching-ledger">
    <div class="d-flex align-center justify-space-between">
      <div v-if="hasCustomerBirthdays" class="customer-birthday">
        <b>{{ customerBirthdays.startOfWeek + ' ～ ' + customerBirthdays.endOfWeek + ' お誕生日の方'}}</b>
        <ul v-if="customerBirthdays.customer_birthdays && customerBirthdays.customer_birthdays.length > 0" class="grid-list">
          <li v-for="(customer, index) in customerBirthdays.customer_birthdays" :key="index">
            <a :href="`/customer/history/${customer.id}`">{{ customer.birthday + ' ' + customerName(customer) }}</a>
          </li>
        </ul>
        <p v-else>データはありません。</p>
      </div>
      <div class="font-weight-bold text-30px align-right">お見合い台帳</div>
      <div>
        <v-btn class="info" type="button" @click="onPrint"> 印刷する</v-btn>
      </div>
    </div>

    <div class="mt-3 d-flex align-center">
      <v-flex xs12 md9 class="d-flex align-center justify-start">
        <div class="mr-6 text-subtitle-1 d-flex align-center">
          <span class="mr-6 text-subtitle-1 d-inline-block" style="width: 53px">
            支店名:</span>
          <v-autocomplete v-model="shopId" :items="shops" @change="onChangeShop" style="width: 150px"></v-autocomplete>
        </div>
        <div class="d-flex font-weight-bold" style="width: 200px">
          <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="currentDate"
            transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="currentDateFormatted" class="red--text" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="currentDate" :day-format="(target_date) => new Date(target_date).getDate()" no-title
              scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="onChangeDate">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        <v-btn class="info ms-5" type="button" @click="updateLedgerWithTargetDate"> 更新</v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="info" dark v-bind="attrs" v-on="on" active="true" class="info ms-4"
              type="button">経緯表入力</v-btn>
          </template>
          <v-list>
            <p ref="pCloseMenu" hidden></p>
            <CompanyVisit :date="currentDate" :counselors="counselorsForForm" :shop_id="shopId"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" :isOnlineShop="isOnlineShop" />
            <InHouseMatchmaking :date="currentDate" :shop_id="shopId" :counselors="counselorsForForm"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" :isOnlineShop="isOnlineShop" />
            <PartnerSelection :date="currentDate" :counselors="counselorsForForm" :shop_id="shopId"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" :isOnlineShop="isOnlineShop" />
            <ConnectMatchmaking :date="currentDate" :shop_id="shopId" :counselors="counselorsForForm"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" :isOnlineShop="isOnlineShop" />
            <DateMatchmaking :date="currentDate" :counselors="counselorsForForm" :shop_id="shopId"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" />
            <OtherHistoryTable :date="currentDate" :counselors="counselorMasters" :shop_id="shopId"
              @closeMenu="closeMenu" :isLedgerScreen="true" @refreshLedgerData="getDataLedger" />
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex xs12 md3 class="d-flex align-center justify-end">
        <div class="d-flex align-center mr-5">
          <label class="text-subtitle-1 mr-3" style="width: 38px">午前:</label>
          <v-autocomplete :items="counselorOption" item-text="text" item-value="value"
            style="width: 150px"></v-autocomplete>
        </div>
        <div class="d-flex align-center">
          <label class="text-subtitle-1 mr-3" style="width: 38px">午後:</label>
          <v-autocomplete :items="counselorOption" item-text="text" item-value="value"
            style="width: 150px"></v-autocomplete>
        </div>
      </v-flex>
    </div>
    <!--      Booth -->
    <v-data-table v-if="!isOnlineShop" :headers="headers" :items="boothsData" :disable-sort="true" :server-items-length="boothsData.length"
      hide-default-footer hide-default-header dense class="fluid-table elevation-1">
      <template v-slot:header>
        <tr>
          <th v-for="header in headers" :key="header.value"
            :class="'pa-1 text-no-wrap text-body-2 font-weight-medium invalid ' + (header.value === 'name' ? 'head-col' : '') + (boothsData.length === 0 ? ' no-data' : '')">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:body="{ items }">
        <tr v-for="item in items" :key="item.id">
          <td class="head-col text-caption pa-1" :title="item.name">
            <div class="text-truncate text-center w-100">{{ item.name }}</div>
            <div class="text-truncate text-center w-100">
              {{ item.type === 1 ? 'ＣＯブース' : '' }}
            </div>
          </td>
          <td v-for="(el, index) in headers.slice(1)" :key="index" class="block-td">
            <MatchingLedgerItem type="booth" v-if="el.value !== 'shopName' && item[el.value][0]?.id"
              @open-modal="showDuplicateAppointmentDialog"
              v-bind:time-range="el"
              v-bind:isBoothNo="1"
              v-bind:time-slot="item[el.value][0]" :counselorMasters="counselorMasters"></MatchingLedgerItem>
          </td>
        </tr>
        <tbody v-if="boothsData.length === 0">
          <tr>
            <td colspan="12" style="color: rgba(0, 0, 0, 0.38)">記録はありません</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <!--      Counseling -->
    <v-data-table :headers="headers" :items="counselingData" :disable-sort="true"
      :server-items-length="counselingData.length" hide-default-footer hide-default-header
      class="fluid-table elevation-1">
      <template v-slot:header>
        <tr>
          <th v-for="header in headers" style="background: rgb(230, 230, 230);" :key="header.value"
            :class="'pa-1 text-body-2 font-weight-medium invalid ' + (header.value === 'name' ? 'head-col' : '') + (counselingData.length === 0 ? ' no-data' : '')">
            {{ header.value === 'name' ? 'カウンセリング' : header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:body="{ items }">
        <tr v-for="item in items" :key="item.id">
          <td class="head-col text-caption pa-1" :title="item.name">
            <div class="text-truncate text-center w-100">{{ item.name }}</div>
          </td>
          <td v-for="(el, index) in headers.slice(1)" :key="index" class="block-td">
            <MatchingLedgerItem type="counseling" v-if="el.value !== 'shopName' && item[el.value][0]?.id"
              @open-modal="showDuplicateAppointmentDialog"
              v-bind:time-range="el"
              v-bind:isBoothNo="0"
              v-bind:time-slot="item[el.value][0]" :counselorMasters="counselorMasters"></MatchingLedgerItem>
          </td>
        </tr>
        <tbody v-if="counselingData.length === 0">
          <tr>
            <td colspan="12" style="color: rgba(0, 0, 0, 0.38)">記録はありません</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <!--      Others -->
    <v-data-table :headers="headersColspan" :items="othersData" :disable-sort="true"
      :server-items-length="othersData.length" hide-default-footer hide-default-header dense
      class="fluid-table others elevation-1">
      <template v-slot:header>
        <tr>
          <th v-for="header in headersColspan" :key="header.value"
            :class="'pa-1 text-no-wrap text-body-2 font-weight-medium invalid ' + (header.value === 'name' ? 'head-col' : '') + (othersData.length === 0 ? ' no-data' : '')">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:body="{ items }">
        <tr v-for="item in items" :key="item.id">
          <td class="head-col text-caption pa-1" :title="item.name">
            <div class="text-truncate text-center w-100">{{ item.name }}</div>
          </td>
          <td v-for="(el, index) in headersColspan.slice(1)" :key="index" class=""
            :style="{ width: el.value !== '19:00:00' ? 'calc((84vw - 110px) * 3 / 11)' : 'calc((84vw - 110px) * 2 / 11)', verticalAlign: 'top' }">
            <div v-if="item.type !== 'note'" class="d-flex">
              <div
                v-for="(col, index) in blockColumns(item[el.value].slice(0, el.value !== '19:00:00' ? 6 : 4), el.value !== '19:00:00' ? 6 : 4, 2)"
                :key="index" :class="'block-item ' + `block-${index}` + (el.value === '19:00:00' ? ' two-block' : '')">
                <div v-for="(time, i) in col" :key="i" :class="col.length ? 'has-data' : ''"
                  @click="redirectToHistory(time.customer_id, time.id)" style="cursor: pointer">
                  <div class="text-caption text-truncate h-20"
                    :title="`${formatTime(time.target_time)}/${getKindShortName(time)}`">
                    {{ formatTime(time.target_time) }}/{{ getKindShortName(time) }}
                  </div>
                  <div v-if="time.type === 3 && time.customer.hasOwnProperty('gender')"
                       :title="getCustomerSpecificMale(time)"
                       class="text-caption border-dashed text-truncate px-1 h-20"
                       :class="{ 'text-red': [CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(time.customer_id) }"
                  >
                    {{ getCustomerSpecificMale(time) }}
                  </div>
                  <div v-if="time.type === 4 && time.customer.hasOwnProperty('gender')"
                       :title="getCustomerSpecificMale(time)" class="text-caption border-dashed text-truncate px-1 h-20" :class="{ 'text-red': [CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(time.customer_id) }">
                    {{ getCustomerSpecificMale(time) }}
                  </div>
                  <div
                      v-if="time.type === 4 && time.female_customer.hasOwnProperty('id') && time.female_customer.id !== time.customer_id"
                      :title="customerName(time.female_customer)"
                      class="text-caption border-dashed text-truncate px-1 h-20" :class="{ 'text-red': [CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(time.female_customer.id) }">
                    {{ getCustomerSpecificFemale(time) }}
                  </div>
                  <div
                      v-if="time.type === 4 && time.male_customer.hasOwnProperty('id') && time.male_customer.id !== time.customer_id"
                      :title="customerName(time.male_customer)"
                      class="text-caption border-dashed text-truncate px-1 h-20" :class="{ 'text-red': [CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(time.male_customer.id) }">
                    {{ getCustomerSpecificMale(time) }}
                  </div>

                  <!-- Form other -->
                  <div
                      v-if="time.type === 6"
                      class="text-caption border-dashed text-truncate px-1 h-20" :class="{ 'text-red': [CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(time.customer_id) }">
                    {{ getCustomerSpecificFemale(time) }}
                  </div>

                  <!-- blank place -->
                  <div
                    v-if="time.type === 6"
                    class="text-caption border-dashed text-truncate px-1 h-20">
                  </div>
                  <!-- End form other -->

                  <div v-if="triggerBorder[item.type === 3 ? 'connect' : 'date']" :class="'line-td ' + `line-${i}`">
                  </div>
                </div>
                <div v-if="col.length === 0" :style="{ minHeight: item.type === 3 ? '40px' : '60px' }">
                </div>
                <div v-if="col.length === 0 && triggerBorder[item.type === 3 ? 'connect' : 'date']" class="line-td">
                </div>
              </div>
            </div>
            <div v-if="item.type == 'note'">
              <div
                v-for="(col, key) in blockColumns(item[el.value].slice(0, el.value !== '19:00:00' ? 1 : 1), el.value !== '19:00:00' ? 1 : 1, 1)"
                :key="key"
                class="px-2"
              >
                <template v-if="col.length">
                  <div v-for="(time, i) in col" :key="i"
                    style="cursor: pointer;"
                    class="text-caption"
                  >
                    <v-textarea
                      v-if="currentUser.id === time.user_id"
                      v-model="time.note" :ref="`${el.value}_textarea`"
                      @blur="onCreateLedgerNote(el.value, time.note)"
                      @change="isLedgerChange = true"
                      @input="adjustTextarea(`${el.value}_textarea`)"
                      rows="1"
                      auto-grow
                      :maxlength="80"
                      :max-rows="3"
                      hide-details="auto"
                      style="font-size: 12px; padding-top: 0px;"
                      class="ledger-note"
                    >
                    </v-textarea>
                    <p v-else style="font-size: 12px; padding-top: 0px;" class="ledger-note mb-0 text-left">{{ time.note }}</p>
                  </div>
                </template>
                <v-textarea
                  v-else
                  v-model="ledgerNote[index]" :ref="`${el.value}_textarea`"
                  @blur="onCreateLedgerNote(el.value, ledgerNote[index])"
                  @change="isLedgerChange = true"
                  @input="adjustTextarea(`${el.value}_textarea`)"
                  rows="1"
                  auto-grow
                  :maxlength="80"
                  :max-rows="3"
                  hide-details="auto"
                  style="font-size: 12px; padding-top: 0px;"
                  class="ledger-note"
                >
                </v-textarea>
              </div>
            </div>
          </td>
        </tr>
        <tbody v-if="othersData.length === 0">
          <tr>
            <td colspan="12" style="color: rgba(0, 0, 0, 0.38)">記録はありません</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <!-- Duplicate appointment dialog -->
    <v-dialog width="460" v-model="showAppointmentDialog" persistent>
      <template>
        <v-card>
          <v-card-text class="pt-4">
            <p class="mb-0">以下と重複しています。</p>
            <div class="duplicate-appointment">
              <div v-for="(appointment, index) in appointmentData" :key="index" class="mb-2">
                <p class="mb-0">{{ CUSTOMER.EXEC_KIND.getName(appointment.kind) }}</p>
                <p class="mb-0">時間：{{formatTime(appointment.targetTime)}}〜{{formatTime(appointment.targetTimeEnd) }}</p>
                <p class="mb-0">担当：{{appointment.counselorName}}</p>
                <p class="mb-0">ブース：{{appointment.boothNoName}}</p>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn class="info" @click="closeDuplicateAppointmentDialog">閉じる </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>

</template>

<script>
import moment from "moment"
import constants from '@/consts/constants.js'
import MatchingLedgerItem from "@/components/MatchingLedgerItem.vue";
import CUSTOMER from "@/consts/customer";
import CompanyVisit from "@/components/CompanyVisit";
import InHouseMatchmaking from "@/components/InHouseMatchmaking";
import PartnerSelection from "@/components/PartnerSelection";
import ConnectMatchmaking from "@/components/ConnectMatchmaking";
import DateMatchmaking from "@/components/DateMatchmaking";
import OtherHistoryTable from "@/components/OtherHistoryTable";
import { max } from '@/utilities/validation.js';

export default {
  components: {
    MatchingLedgerItem,
    CompanyVisit,
    InHouseMatchmaking,
    PartnerSelection,
    ConnectMatchmaking,
    DateMatchmaking,
    OtherHistoryTable,
  },
  async beforeRouteLeave (to, from, next) {
    await this.onCreateLedgerNote();
    next();
  },
  title: 'お見合い台帳',
  name: 'matching_ledger',
  data: () => {
    return {
      CUSTOMER: CUSTOMER,
      moment: moment,
      menu: false,
      currentDate: '',
      shopId: -1,
      shops: [],
      shopName: '',
      counselorOption: [],
      customerBirthdays: [],
      hasCustomerBirthdays: false,
      headers: [
        { text: 'ブース', value: 'name' },
        { text: '10:00～', value: '10:00:00' },
        { text: '11:00～', value: '11:00:00' },
        { text: '12:00～', value: '12:00:00' },
        { text: '13:00～', value: '13:00:00' },
        { text: '14:00～', value: '14:00:00' },
        { text: '15:00～', value: '15:00:00' },
        { text: '16:00～', value: '16:00:00' },
        { text: '17:00～', value: '17:00:00' },
        { text: '18:00～', value: '18:00:00' },
        { text: '19:00～', value: '19:00:00' },
        { text: '20:00～', value: '20:00:00' }
      ],
      headersColspan: [
        { text: '他', value: 'name' },
        { text: '10:00～13:00', value: '10:00:00_13:00:00' },
        { text: '13:00～16:00', value: '13:00:00_16:00:00' },
        { text: '16:00～19:00', value: '16:00:00_19:00:00' },
        { text: '19:00～', value: '19:00:00' }
      ],
      boothsData: [],
      counselingData: [],
      othersData: [],
      triggerBorder: { connect: false, date: false },
      counselorMasters: [],
      counselorsForForm: [],
      showAppointmentDialog: false,
      appointmentData: [],
      ledgerNote: [],
      currentFrameTime: '',
      currentNote: '',
      isLedgerChange: false,
      // validate
      rules: {
        note: [
          (v) => max(v, 80),
        ],
      },
      currentUser: null,
    }
  },
  created() {
    this.getCO(0);
  },
  computed: {
    currentDateFormatted() {
      return this.currentDate ? this.formatDate(this.currentDate) : this.formatDate(this.date)
    },
    isOnlineShop() {
      const shop = this.shops.find(s => s.value === this.shopId)
      return shop ? shop.is_online == 1 : false
    },
  },
  async mounted() {
    this.shopName = this.$store.state.user.name
    this.currentDate = this.$route.query.date || ''
    this.currentUser = this.$store.state.user
    await this.getShopId()
    await this.getDataLedger()
    await this.getDataCustomerBirthdays()
  },
  methods: {
    addStylePrint() {
      let file = document.createElement('link')
      file.id = 'matching-ledger'
      file.rel = 'stylesheet'
      file.href = 'assets/styles/print-matching-ledger.css'
      document.head.appendChild(file)
    },
    onPrint() {
      this.addStylePrint()
      setTimeout(() => window.print(), 800)
      window.onafterprint = () => {
        document.getElementById('matching-ledger').remove()
      };
    },
    customerName(customer) {
      return (customer.family_name !== "-" ? customer.family_name : '') + ' ' + (customer.given_name !== "-" ? customer.given_name : '')
    },
    formatDate(date) {
      if (!date) return null

      return moment(date).locale('ja').format(constants.FORMAT_DATE_JP + ' (ddd)')
    },
    formatTime(time) {
      const targetDate = this.$route.query.date
      return moment(targetDate + ' ' + time).format('HH:mm')
    },
    redirectToHistory(customerId, query) {
      const routeData = this.$router.resolve({ name: 'customer_history', params: { id: customerId }, query: { id: query, fromScreen: 'ledger' } })
      window.open(routeData.href, '_blank');
    },
    transformBoothData(boothData) {
      this.boothsData = []
      boothData.map(el => this.boothsData.push({ name: el.name, type: el.type, id: el.id, ...el.events }))
    },
    transformCounselingData(counselingData) {
      this.counselingData = []
      this.counselorOption = []
      counselingData.map(el => {
        this.counselingData.push({ name: el.name, id: el.id, ...el.events })
        this.counselorOption.push({ text: el.name, value: el.id })
      })
    },
    checkSameEyeLedger(sources) {
      return sources.map((entry) => {
        const newEntry = { ...entry };
        const events = { ...newEntry.events };
        const last = {
          timeEnd: null,
          id: null,
          end: null,
          timeSame: null,
          idSame: null
        };
        Object.keys(events).forEach((key) => {
          if (events[key].length) {
            if (events[key][0].sameBooth) {
              if (key >= events[key][0].min_time_start && key < events[key][0].max_time_end)
                events[key][0].isSame = true
            } else if (events[key][0].sameCounselors) {
              if (key >= events[key][0].min_time_start && key < events[key][0].max_time_end)
                events[key][0].isSame = true
            } else {
              // check the id, if equal then attach isSame to the previous record, if different then check the target time condition
              if (events[key][0].id == last.id) {
                events[key][0].isSame = last.isSame;
              } else {
                events[key][0].isSame = events[key][0].target_time <= last.timeEnd && events[key][0].target_time !== last.end;
                if (!last.timeSame || last.timeEnd > last.timeSame) {
                  last.timeSame = last.timeEnd
                }
              }

              // isSame = false, reattach the value to last.end
              if (!events[key][0].isSame) {
                last.end = events[key][0].target_time_end;
                last.idSame = events[key][0].id
              } else {
                if (key >= last.timeSame || last.idSame == events[key][0].id) {
                  events[key][0].isSame = false;
                }

              }
              last.timeEnd = events[key][0].target_time_end;
              last.id = events[key][0].id;
              last.isSame = events[key][0].isSame;
            }
          }
        });
        newEntry.events = events;
        return newEntry;
      });
    },
    checkBorder() {
      this.triggerBorder = { connect: false, date: false }
      this.headersColspan.slice(1).map(e => {
        this.othersData.slice(0, 2).map(el => {
          if (el[e.value].length > 1) {
            if (el.type === 3) {
              this.triggerBorder.connect = true
            }
            if (el.type === 4) {
              this.triggerBorder.date = true
            }
          }
        })
      })
    },
    checkSameEyeLedgerReverse(sources) {
      return sources.map((entry) => {
        const last = {
          start: null,
          end: null,
          id: null,
          min: 10,
          max: 20,
          minTimeStart: null
        }
        Object.keys(entry.events).forEach(function (key) {
          if (entry.events[key].length) {
            const record = entry.events[key][0]
            if (record.id !== last.id
              &&
              record.target_time <= last.start && record.target_time <= last.end
            ) {
              for (let i = last.min; i < key.substring(0, 2) * 1; i++) {
                if (entry.events[i + ':00:00'].length && (!last.minTimeStart || last.minTimeStart > entry.events[i + ':00:00'][0].target_time)) {
                  if (entry.events[i + ':00:00'][0].isSame) {
                    last.minTimeStart = entry.events[i + ':00:00'][0].target_time
                  }
                }

                if (entry.events[i + ':00:00'].length && entry.events[i + ':00:00'][0].id != record.id) {
                  entry.events[i + ':00:00'][0].isSame = true
                  entry.events[i + ':00:00'][0].reverse_min_time_start = last.minTimeStart
                }
                if (entry.events[i + ':00:00'].length
                  && (!entry.events[i + ':00:00'][0].reverse_min_time_start || entry.events[i + ':00:00'][0].target_time < entry.events[i + ':00:00'][0].reverse_min_time_start)) {
                  entry.events[i + ':00:00'][0].isSame = false
                  if (entry.events[i + ':00:00'][0].sameBooth || entry.events[i + ':00:00'][0].sameCounselors) {
                    entry.events[i + ':00:00'][0].isSame = true
                  }
                }
              }
            }
            last.start = record.target_time
            last.end = record.target_time_end
            last.id = record.id
          }
        })
        return entry
      })
    },
    transformOthersData(othersData) {
      this.othersData = []
      othersData.map(el => this.othersData.push({
        name: el.type === 3 ? '連盟見合' : (el.type === 'note' ? 'メモ欄' : 'デート'),
        type: el.type, ...el.events
      }))
      if (this.othersData[0]) {
        const eventTimeCount = Object.keys(this.othersData[0]).length - 2
        if (  eventTimeCount >= 0) {
          this.ledgerNote = Array(eventTimeCount).fill('')  
        }
      }
    },
    blockColumns(dataColumns, maxBlock, chunkSize) {
      let columns = []
      for (let col = 0; col < maxBlock; col += chunkSize) {
        columns.push(dataColumns.length ? dataColumns.slice(col, col + chunkSize) : [])
      }
      return columns
    },
    async getShopId() {
      if (this.shops.length === 0) {
        await this.$axios.get(`/api/v1/shop`)
            .then(response => {
              this.shops = response.data.shops;
            })
        const shop_id = this.$store.state.user.shop_id || this.shops[0].value;
        this.shopId = shop_id;
      }
      return this.shopId;
    },
    async getDataLedger() {
      await this.$axios.get(`/api/v1/eye_ledger?shop_id=${this.shopId}&target_date=${this.currentDate}&user_id=${this.$store.state.user.id}`).then((res) => {
        const booths = this.checkSameEyeLedgerReverse(this.checkSameEyeLedger(res.data.booths))
        // const booths = []
        const counselors = this.checkSameEyeLedgerReverse(this.checkSameEyeLedger(res.data.counselors))
        this.transformBoothData(booths)
        this.transformCounselingData(counselors)
        this.transformOthersData(res.data.others)
        this.checkBorder()
      })
    },
    async getDataCustomerBirthdays() {
      await this.$axios.get(`/api/v1/customer/birthday/list?shop_id=${this.shopId}&target_date=${this.currentDate}`).then((res) => {
        this.customerBirthdays = res.data
        this.hasCustomerBirthdays = res.data.startOfWeek ? true : false
      })
    },
    onChangeShop() {
      this.getDataLedger()
      this.getDataCustomerBirthdays()
      this.getCO(this.shopId)
    },
    onChangeDate() {
      this.$refs.menu.save(this.currentDate)
      if (this.$route.query.date !== this.currentDate) {
        this.$router.push({ 
          path: this.$route.path,
          query: { date: this.currentDate }
        });
      }
      this.getDataLedger();
      this.getDataCustomerBirthdays()
    },
    updateLedgerWithTargetDate() {
      this.onChangeDate();
    },
    getCO(shop_id) {
      const shopIdToGetAllCounselor = 0
      let tmp_shop_id = this.$store.state.user.shop_id;
      if (tmp_shop_id === 0) {
        tmp_shop_id = 1
      }
      if (shop_id) {
        tmp_shop_id = shop_id;
      }
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${shopIdToGetAllCounselor}`)
        .then((response) => {
          this.counselorMasters = response.data.counselors
          const shop = this.shops.find(s => s.value === tmp_shop_id)
          if (shop && shop.is_online == 1) {
            this.counselorsForForm = this.counselorMasters
          } else {
            this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === tmp_shop_id)
          }
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    closeMenu() {
      this.$refs.pCloseMenu.click()
    },
    showDuplicateAppointmentDialog(data) {
      this.appointmentData = data
      this.showAppointmentDialog = true;
    },
    closeDuplicateAppointmentDialog() {
      this.showAppointmentDialog = false;
    },
    async onCreateLedgerNote(frameTime, note) {
      const $toastr = this.$toastr
      if (note && note.length > 80) {
        return
      }
      this.currentFrameTime = frameTime
      this.currentNote = note
      if (this.isLedgerChange) {
        await this.$axios
          .post(`/api/v1/eye_ledger/note`, { 
            frame_time: frameTime,
            note: note,
            shop_id: this.shopId,
            target_date: this.currentDate
          })
          .then(() => {
            $toastr.s('メモを保存しました');
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
        this.isLedgerChange = false
      }
    },
    adjustTextarea(elm) {
      const compnent = this.$refs[elm];
      const textarea = compnent[0].$refs.input;
      setTimeout(() => {
        if (textarea) {
          textarea.style.height = 'auto';
          textarea.style.height = `${textarea.scrollHeight}px`;
          // Calculate the line height of the textarea
          let lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10);

          let maxHeight = lineHeight * 3;
          // Get the current scroll height of the textarea content
          let contentHeight = textarea.scrollHeight;
          if (!(contentHeight <= maxHeight)) {
            textarea.value = textarea.value.slice(0, textarea.value.length - 1);
            textarea.value = textarea.value.split('\n').slice(0, 3).join('\n');
          }
        }
      }, 0)
    },
    getCustomerSpecificMale(customer) {
      if (CUSTOMER.FUKUOKA_MALE.id === customer.customer_id) {
        return CUSTOMER.FUKUOKA_MALE.name
      }
      if (CUSTOMER.HIROSHIMA_MALE.id === customer.customer_id) {
        return CUSTOMER.HIROSHIMA_MALE.name
      }

      if (customer.kind !== 26) {
        if (customer.male_customer.id) {
          return this.customerName(customer.male_customer)
        }
      }
      return this.customerName(customer.customer)
    },
    getCustomerSpecificFemale(customer) {
      if (customer.kind !== 26) {
        if (customer.female_customer.id) {
          return this.customerName(customer.female_customer)
        }
      }
      return this.customerName(customer.customer)
    },
    // 連盟見合の場合、connect_flagに基づいた短縮名を返す
    getKindShortName(time) {
      if (time.kind === this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING && time.connect_flag) {
        return time.connect_flag === this.CUSTOMER.CONNECT_FLAG.VAL.CONNECT ? 'コネ見' : 'IBJ見';
      }
      return this.CUSTOMER.EXEC_KIND.getShort(time.kind);
    }
  }
}
</script>

<style scoped lang="scss" media="print">
* {
  box-sizing: border-box;
}

@media only screen and (min-width: 1037px) {
  .align-right {
    margin-right: 25%;
  }
}

@media only screen and (max-width: 768px) {
  .customer-birthday {
    width: 59% !important;
  }
}

.fluid-table {
  margin-bottom: 24px;

  th,
  td {
    text-align: center;
    border-right: thin solid rgba(0, 0, 0, 0.38);
    border-bottom: thin solid rgba(0, 0, 0, 0.38);
  }

  th {
    border-top: thin solid rgba(0, 0, 0, 0.38);
  }

  td {
    padding: 1px;

    &:not(:first-child) {
      vertical-align: top;
    }
  }

  th:first-child,
  td:first-child {
    border-left: thin solid rgba(0, 0, 0, 0.38);
  }

  &.others {
    td {
      padding: 0;
    }
  }

  .head-col {
    position: sticky;
    background: #fff;
    width: 110px;
    left: 0;
    text-align: center !important;

    &.text-no-wrap {
      background: rgb(230, 230, 230);
    }
  }
}

.text-30px {
  font-size: 30px;
}

.w-100 {
  width: 100px;
}

.h-20 {
  height: 20px;
}

.line-td {
  width: 100%;
  border-bottom: thin solid rgba(0, 0, 0, 0.38);

  &.line-1 {
    border-bottom: none;
  }
}

.has-data {
  border-right: thin solid rgba(0, 0, 0, 0.38);
}

.block-2 {
  .has-data {
    border-right: none;
  }
}

.block-item {
  display: flex;
  flex-direction: column;
  min-width: 135px;
  width: calc((84vw - 112px) / 11);
}

.block-td {
  width: calc((84vw - 112px) / 11);
  min-width: 135px;
}

.border-dashed {
  border-top: thin dashed rgba(0, 0, 0, 0.12);
}

.customer-birthday {
  border: thin solid rgba(0, 0, 0, 0.38);
  padding: 10px;
  font-size: 14px;
  min-height: 19vh;
  width: 482px;
}

.customer-birthday p {
  padding: 18px 33px 0 10px;
}

.grid-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px 37px;
  list-style-type: none;
  padding: 18px 33px 0 10px;
}

.grid-list a {
  text-decoration: none;
}

.grid-list li:nth-child(1),
.grid-list li:nth-child(2),
.grid-list li:nth-child(3) {
  grid-column: 1;
}

.grid-list li:nth-child(1),
.grid-list li:nth-child(4) {
  grid-row: 1;
}

.grid-list li:nth-child(2),
.grid-list li:nth-child(5) {
  grid-row: 2;
}

.grid-list li:nth-child(3),
.grid-list li:nth-child(6) {
  grid-row: 3;
}

.grid-list li:nth-child(4),
.grid-list li:nth-child(5),
.grid-list li:nth-child(6) {
  grid-column: 2;
}

.duplicate-appointment {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.text-red {
  color: red;
}
</style>
